import React, { useEffect, useState } from "react";
import {
  Routes,
  Route,
  BrowserRouter as Router,
  Navigate,
} from "react-router-dom";
import { Spin } from "antd";

import { AppRoutes } from "./data";
import AppLayout from "./components/Layout/Layout";
import MyComponent from "./MyComponent";
import LoginPage from "./pages/LoginPage";
import SuperAdminLoginPage from "./pages/SuperAdminLoginPage";
import HomePage from "./pages/HomePage";
import { getUserAuthToken } from "./helpers/userDetails";

const RoutesWrapper = () => {
  // Initialize with auth check to prevent redirect on reload
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(() => {
    const token = getUserAuthToken();
    return token !== "";
  });
  const [isCheckingAuth, setIsCheckingAuth] = useState<boolean>(true);

  useEffect(() => {
    // Initial check
    const checkAuth = () => {
      const token = getUserAuthToken();
      setIsLoggedIn(token !== "");
      setIsCheckingAuth(false);
    };

    // Small delay to ensure localStorage is accessible
    const timer = setTimeout(checkAuth, 0);

    // Check auth on storage changes (e.g., when login sets token)
    const handleStorageChange = () => {
      const token = getUserAuthToken();
      setIsLoggedIn(token !== "");
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  // Show loading while checking auth on initial load
  if (isCheckingAuth) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={isLoggedIn ? <Navigate to="/" replace /> : <LoginPage />}
        />
        <Route
          path="/login-super-admin"
          element={isLoggedIn ? <Navigate to="/" replace /> : <SuperAdminLoginPage />}
        />
        <Route
          path="/*"
          element={
            isLoggedIn ? <AppLayout /> : <Navigate to="/login" replace />
          }
        />
      </Routes>
    </Router>
  );
};

export default RoutesWrapper;
